import React from 'react';
import { useNavigate } from 'react-router-dom';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    localStorage.clear();
    onClose();
    navigate('/');
  };

  const handleBackToLogin = () => {
    localStorage.clear();
    onClose();
    navigate('/');
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed left-[255px] top-[72px]  right-0 bottom-0 z-[9999] flex items-center justify-center"
      style={{
        background:
          'linear-gradient(174.07deg, rgba(173, 12, 98, 0.85) 0.38%, rgba(98, 28, 67, 0.85) 95.87%)',
      }}
    >
      <div className="bg-[#621C43] max-w-md w-full rounded-xl text-white relative shadow-xl border border-[#7a2757]">
        <button
          onClick={handleClose}
          className="absolute top-2 right-4 text-white hover:text-gray-300 text-xl font-bold"
          aria-label="Close popup"
        >
          &times;
        </button>

        <div className="border-b p-4 border-[#FFF8ED]">
          <h2 className="text-lg font-semibold text-center">Session Expired</h2>
        </div>

        <div className="text-center p-6">
          <div className="w-20 h-20 bg-gradient-to-br from-red-400 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg animate-pulse">
            <svg
              className="w-10 h-10 text-white drop-shadow-sm"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <p className="text-[#FFF8ED] font-medium leading-relaxed">
            Your session has expired due to inactivity.
            <br />
            <span className="text-[#EEE] text-sm">Please login again to continue securely.</span>
          </p>
        </div>

        <div className="flex justify-between gap-3 py-5 px-6 border-t border-black">
          <button
            onClick={handleClose}
            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white py-2 rounded-md text-sm"
          >
            Close
          </button>
          <button
            onClick={handleBackToLogin}
            className="flex-1 bg-[#4C86E7] hover:bg-[#4679d1] rounded-md py-2 text-sm"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
